import { useState } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { TKIconClose, TKIconPencil, TKIconShare } from "assets/images/svgs";
import { useDispatch } from "react-redux";
import { getDonationPerProject } from "appState/donation/donationSlice";

const ProjectDashboardCard = ({
  id,
  title,
  cardImage,
  createdAt,
  amountRaised,
  targetAmount,
  status,
  donateTypes,
  impact_of_donated_item,
  impact_of_monetary_goal,
  projected_impact,
  summary,
  projectData,
}) => {
  const navigate = useNavigate();
  const [toggle, setToggle] = useState(false);
  const [currentId, setcurrentId] = useState(0);

  const percentage = Math.floor((amountRaised / targetAmount) * 100);

  const width = `w-[${percentage}%]`;

  const dispatch = useDispatch();

  const handleDonationsNavigate = () => {
    dispatch(getDonationPerProject({ id: currentId })).then((data) => {
      if (data?.payload?.status === 200) {
        let path = `/ngo/projects/${currentId}/donations`;
        navigate(path, { state: title });
      }
    });
  };

  const handleEditNavigate = () => {
    let path = `/ngo/projects/create-project`;
    navigate(path, { state: projectData });
  };

  return (
    <div className="">
      {toggle && (
        <div className="flex">
          <div
            className={
              "absolute h-screen max-[600px]:w-[80%] w-2/5 bg-white top-0 right-0 z-[99999999] flex flex-col py-3 gap-4 overflow-y-auto"
            }
          >
            <div className="px-3 flex justify-end">
              <TKIconClose onClick={() => setToggle(false)} />
            </div>
            <div className="px-3 w-full h-[300px]">
              <img
                className="w-full h-full rounded-lg object-cover"
                src={cardImage}
                alt={`TK-${id}`}
              />
            </div>
            <div className="px-3 flex justify-between gap-x-2 items-center">
              <p className="text-[#7A7A7A] text-[10px]">
                Creation Date: {createdAt}
              </p>
              <p
                className={`capitalize text-[10px] font-semibold ${
                  status === "active"
                    ? "text-[#61CE70]"
                    : status === "pending"
                    ? "text-[#F57200]"
                    : "text-[#C81818]"
                }`}
              >
                {status}
              </p>
            </div>
            <div className="px-3 gap-2 flex flex-col">
              <div className="flex justify-between gap-x-2 items-center">
                <p className="text-[14px] capitalize font-bold">{title}</p>
                <div
                  className={`flex justify-center items-center w-[37px] h-[37px] left-3 bottom-3 text-[12px] rounded-full border-2 bg-transparent ${
                    status === "active"
                      ? "border-[#61CE70]"
                      : status === "pending"
                      ? "border-[#F57200]"
                      : "border-[#C81818]"
                  }`}
                >
                  <div
                    className={`${
                      status === "active"
                        ? "bg-[#61CE70]"
                        : status === "pending"
                        ? "bg-[#F57200]"
                        : "bg-[#C81818] text-white"
                    } rounded-full`}
                  >
                    <p className="p-1 w-[28px] h-[28px]">{percentage}%</p>
                  </div>
                </div>
              </div>
              <div className="my-2 flex bg-[#CCCCCC]">
                <div
                  className={`h-[10px] ${
                    status === "active"
                      ? "bg-[#61CE70]"
                      : status === "pending"
                      ? "bg-[#F57200]"
                      : "bg-[#C81818]"
                  } ${width}`}
                ></div>
              </div>
              <div className="flex justify-between">
                <p className="text-[#7A7A7A] text-[12px] font-semibold">
                  N{amountRaised}
                </p>
                <p className="text-[12px] font-semibold">N{targetAmount}</p>
              </div>
            </div>
            <div className="px-3 flex justify-between gap-2">
              <div className="flex gap-2 justify-between">
                <div
                  onClick={handleEditNavigate}
                  className={`flex gap-x-1 justify-center cursor-pointer rounded-lg py-2 px-1 border border-[#213874] text-[#213874] text-[12px] whitespace-nowrap`}
                >
                  <TKIconPencil />
                  <p>Edit Project</p>
                </div>
                <div
                  className={`flex gap-x-1 justify-center items-center cursor-pointer rounded-lg py-2 px-2 border border-[#213874] text-[#213874] text-[12px] whitespace-nowrap hover:font-bold`}
                >
                  <TKIconShare />
                </div>
              </div>
              <div>
                <p
                  onClick={handleDonationsNavigate}
                  className="px-4 cursor-pointer py-2 border border-[#CCC] rounded-lg bg-[#7A7A7A] text-white"
                >
                  Donations
                </p>
              </div>
            </div>
            <div className="px-3 flex flex-col gap-4">
              <div className="flex justify-between">
                <p className="px-4 py-2 border border-[#CCC] rounded-lg">
                  Descriptions
                </p>
              </div>
              <div className="flex flex-col gap-3">
                <div className="flex justify-between items-center gap-2">
                  <p className="text-[12px] text-[#7A7A7A]">Project Summary</p>
                  <p className="text-[12px]">{summary}</p>
                </div>
                <div className="flex justify-between items-center gap-2">
                  <p className="text-[12px] text-[#7A7A7A]">
                    Impact of donated item
                  </p>
                  <p className="text-[12px]">{impact_of_donated_item}</p>
                </div>
                <div className="flex justify-between items-center gap-2">
                  <p className="text-[12px] text-[#7A7A7A]">
                    Impact of monetary goal
                  </p>
                  <p className="text-[12px]">{impact_of_monetary_goal}</p>
                </div>
                <div className="flex justify-between items-center gap-2">
                  <p className="text-[12px] text-[#7A7A7A]">Projected impact</p>
                  <p className="text-[12px]">{projected_impact}</p>
                </div>
                <div className="flex justify-between items-center gap-2">
                  <p className="w-[120px] text-[12px] text-[#7A7A7A]">
                    Donation Type(s)
                  </p>
                  <div className="flex gap-4">
                    {donateTypes.map((type, index) => (
                      <p
                        key={index}
                        className={`text-[12px] text-[#3C3C4E] capitalize py-1 px-2 rounded-2xl ${
                          type === "cash"
                            ? "bg-[#EBFFEB]"
                            : type === "volunteer"
                            ? "bg-[#FFF1E2]"
                            : "bg-[#F1EEFF]"
                        }`}
                      >
                        {type}
                      </p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            onClick={() => setToggle(false)}
            className="fixed inset-0 bg-black opacity-40 z-10"
          ></div>
        </div>
      )}
      <div className="flex flex-col rounded-lg shadow-lg">
        <div className="relative w-full h-[200px]">
          <img
            className="w-full rounded-t-lg h-full object-cover"
            src={cardImage}
            alt={`TK-${id}`}
          />
          <div
            className={`absolute flex justify-center items-center w-[37px] h-[37px] left-3 bottom-3 text-[12px] rounded-full border-2 bg-transparent border-white`}
          >
            <div className="bg-white rounded-full">
              <Paragraph
                currentId={currentId}
                className="p-1 w-[28px] h-[28px]"
              >
                {percentage}%
              </Paragraph>
            </div>
          </div>
        </div>
        <div className="flex flex-col p-4 gap-y-3">
          <div className="flex justify-between gap-x-2 items-center">
            <p className="text-[#7A7A7A] text-[10px]">
              Creation Date: {createdAt}
            </p>
            <p
              className={`capitalize text-[10px] font-semibold ${
                status === "active"
                  ? "text-[#61CE70]"
                  : status === "pending"
                  ? "text-[#F57200]"
                  : "text-[#C81818]"
              }`}
            >
              {status}
            </p>
          </div>
          <div>
            <p className="text-[14px] capitalize font-bold">{title}</p>
          </div>
          <div className="flex gap-3 flex-wrap">
            {donateTypes.map((type, index) => (
              <p
                key={index}
                className={`text-[12px] text-[#3C3C4E] capitalize py-1 px-2 rounded-2xl ${
                  type === "cash"
                    ? "bg-[#EBFFEB]"
                    : type === "volunteer"
                    ? "bg-[#FFF1E2]"
                    : "bg-[#F1EEFF]"
                }`}
              >
                {type}
              </p>
            ))}
          </div>
          <div
            onClick={() => {
              setcurrentId(id);
              setToggle(true);
            }}
            className={`flex gap-x-1 justify-center cursor-pointer rounded-lg py-2 px-1 border border-[#213874] text-[#213874] text-[12px] whitespace-nowrap hover:font-bold`}
          >
            <TKIconPencil />
            <p>Edit Project</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDashboardCard;

const Paragraph = styled.div`
  background: -webkit-linear-gradient(#f57200, #d9d9d9);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
`;
